// src/app/shared/auth/keycloak/logout-service/logout.token.ts
import { InjectionToken } from '@angular/core';
import { IOpenUserManagementService } from '@app/shared/auth/user-management/open-user-management-service';

export const OPEN_USER_MANAGEMENT = new InjectionToken<IOpenUserManagementService>(
  'IOpenUserManagementService',
);

export const USER_MANAGEMENT_URL = new InjectionToken<string>('UserManagementUrl');
